
(function () {
  "use strict";

  if (window.KdkPreviewSharedScene) return;

  const VERSION = 1;
  const HOST = window.location.hostname || "shop";
  const META_KEY = `kdk_preview_shared_scene_v${VERSION}:${HOST}:meta`;
  const PHOTO_KEY = `kdk_preview_shared_scene_v${VERSION}:${HOST}:photo`;
  const DB_NAME = "kdk_preview_shared_scene";
  const STORE_NAME = "blobs";

  let dbPromise = null;

  function safeParse(text) {
    if (!text || typeof text !== "string") return null;
    try { return JSON.parse(text); } catch (_) { return null; }
  }

  function getDb() {
    if (dbPromise) return dbPromise;

    dbPromise = new Promise((resolve) => {
      if (!("indexedDB" in window)) {
        resolve(null);
        return;
      }

      let request;
      try {
        request = indexedDB.open(DB_NAME, 1);
      } catch (_) {
        resolve(null);
        return;
      }

      request.onupgradeneeded = () => {
        const db = request.result;
        if (!db.objectStoreNames.contains(STORE_NAME)) {
          db.createObjectStore(STORE_NAME);
        }
      };
      request.onsuccess = () => resolve(request.result || null);
      request.onerror = () => resolve(null);
      request.onblocked = () => resolve(null);
    });

    return dbPromise;
  }

  async function getBlob(key) {
    const db = await getDb();
    if (!db) return null;

    return new Promise((resolve) => {
      try {
        const tx = db.transaction(STORE_NAME, "readonly");
        const req = tx.objectStore(STORE_NAME).get(key);
        req.onsuccess = () => resolve(req.result instanceof Blob ? req.result : null);
        req.onerror = () => resolve(null);
        tx.onabort = () => resolve(null);
      } catch (_) {
        resolve(null);
      }
    });
  }

  async function setBlob(key, blob) {
    const db = await getDb();
    if (!db || !blob) return false;

    return new Promise((resolve) => {
      try {
        const tx = db.transaction(STORE_NAME, "readwrite");
        tx.objectStore(STORE_NAME).put(blob, key);
        tx.oncomplete = () => resolve(true);
        tx.onerror = () => resolve(false);
        tx.onabort = () => resolve(false);
      } catch (_) {
        resolve(false);
      }
    });
  }

  async function deleteBlob(key) {
    const db = await getDb();
    if (!db) return false;

    return new Promise((resolve) => {
      try {
        const tx = db.transaction(STORE_NAME, "readwrite");
        tx.objectStore(STORE_NAME).delete(key);
        tx.oncomplete = () => resolve(true);
        tx.onerror = () => resolve(false);
        tx.onabort = () => resolve(false);
      } catch (_) {
        resolve(false);
      }
    });
  }

  function normalizePoints(points, width, height) {
    if (!Array.isArray(points) || !width || !height) return [];
    return points.map((p) => ({
      x: Math.max(0, Math.min(1, Number(p.x || 0) / width)),
      y: Math.max(0, Math.min(1, Number(p.y || 0) / height))
    }));
  }

  function denormalizePoints(points, width, height) {
    if (!Array.isArray(points) || !width || !height) return [];
    return points.map((p) => ({
      x: (Number(p.x || 0) * width),
      y: (Number(p.y || 0) * height)
    }));
  }

  function loadMeta() {
    return safeParse(localStorage.getItem(META_KEY)) || null;
  }

  function saveMeta(meta) {
    try {
      localStorage.setItem(META_KEY, JSON.stringify(meta || {}));
      return true;
    } catch (_) {
      return false;
    }
  }

  function clearMeta() {
    try { localStorage.removeItem(META_KEY); } catch (_) {}
  }

  function canvasToBlob(canvas, type = "image/jpeg", quality = 0.9) {
    return new Promise((resolve) => {
      if (!canvas || !canvas.toBlob) {
        resolve(null);
        return;
      }
      canvas.toBlob((blob) => resolve(blob || null), type, quality);
    });
  }

  async function savePhotoCanvas(canvas) {
    const blob = await canvasToBlob(canvas, "image/jpeg", 0.9);
    if (!blob) return false;
    return setBlob(PHOTO_KEY, blob);
  }

  async function loadPhotoBlob() {
    return getBlob(PHOTO_KEY);
  }

  async function clearPhoto() {
    return deleteBlob(PHOTO_KEY);
  }

  window.KdkPreviewSharedScene = {
    version: VERSION,
    metaKey: META_KEY,
    photoKey: PHOTO_KEY,
    loadMeta,
    saveMeta,
    clearMeta,
    savePhotoCanvas,
    loadPhotoBlob,
    clearPhoto,
    normalizePoints,
    denormalizePoints
  };
})();
